export var BackupJobType;
(function (BackupJobType) {
    BackupJobType["BackupJobTypeUnspecified"] = "BACKUP_JOB_TYPE_UNSPECIFIED";
    BackupJobType["AwsEc2Backup"] = "AWS_EC2_BACKUP";
    BackupJobType["AwsEbsVolumeBackup"] = "AWS_EBS_VOLUME_BACKUP";
    BackupJobType["AwsEc2SnapshotConversion"] = "AWS_EC2_SNAPSHOT_CONVERSION";
    BackupJobType["AwsRdsBackup"] = "AWS_RDS_BACKUP";
    BackupJobType["AwsS3Backup"] = "AWS_S3_BACKUP";
    BackupJobType["AwsS3LlgBackup"] = "AWS_S3_LLG_BACKUP";
    BackupJobType["AwsFsxBackup"] = "AWS_FSX_BACKUP";
    BackupJobType["AwsEfsBackup"] = "AWS_EFS_BACKUP";
    BackupJobType["AwsDocumentdbBackup"] = "AWS_DOCUMENTDB_BACKUP";
    BackupJobType["AwsNeptuneBackup"] = "AWS_NEPTUNE_BACKUP";
    BackupJobType["AwsDynamoDbBackup"] = "AWS_DYNAMO_DB_BACKUP";
    BackupJobType["AwsDynamoDbBackupFull"] = "AWS_DYNAMO_DB_BACKUP_FULL";
    BackupJobType["AwsDynamoDbBackupFullExport"] = "AWS_DYNAMO_DB_BACKUP_FULL_EXPORT";
    BackupJobType["AwsEksNamespaceBackup"] = "AWS_EKS_NAMESPACE_BACKUP";
    BackupJobType["AwsEksClusterBackup"] = "AWS_EKS_CLUSTER_BACKUP";
    BackupJobType["AwsKeyspacesBackupFull"] = "AWS_KEYSPACES_BACKUP_FULL";
    BackupJobType["AwsCassandraClusterBackup"] = "AWS_CASSANDRA_CLUSTER_BACKUP";
    BackupJobType["AwsOpensearchBackup"] = "AWS_OPENSEARCH_BACKUP";
    BackupJobType["AzureStorageAccountBackup"] = "AZURE_STORAGE_ACCOUNT_BACKUP";
    BackupJobType["AzureVmBackup"] = "AZURE_VM_BACKUP";
    BackupJobType["AzureVmRestorePointConversion"] = "AZURE_VM_RESTORE_POINT_CONVERSION";
    BackupJobType["AzureSqlDatabaseBackup"] = "AZURE_SQL_DATABASE_BACKUP";
    BackupJobType["AzureSqlManagedInstanceBackup"] = "AZURE_SQL_MANAGED_INSTANCE_BACKUP";
    BackupJobType["AzureSqlVirtualMachineBackup"] = "AZURE_SQL_VIRTUAL_MACHINE_BACKUP";
    BackupJobType["AzureSqlVirtualMachineBackupFull"] = "AZURE_SQL_VIRTUAL_MACHINE_BACKUP_FULL";
    BackupJobType["AzurePostgresqlBackup"] = "AZURE_POSTGRESQL_BACKUP";
    BackupJobType["AzureMysqlBackup"] = "AZURE_MYSQL_BACKUP";
    BackupJobType["GcpComputeEngineInstanceBackup"] = "GCP_COMPUTE_ENGINE_INSTANCE_BACKUP";
    BackupJobType["GcpDiskBackup"] = "GCP_DISK_BACKUP";
    BackupJobType["GcpCloudStorageBackup"] = "GCP_CLOUD_STORAGE_BACKUP";
    BackupJobType["GcpCloudSqlBackup"] = "GCP_CLOUD_SQL_BACKUP";
    BackupJobType["GcpBigqueryBackup"] = "GCP_BIGQUERY_BACKUP";
    BackupJobType["GcpSapHanaVmBackup"] = "GCP_SAP_HANA_VM_BACKUP";
    BackupJobType["GcpSqlVmBackup"] = "GCP_SQL_VM_BACKUP";
    BackupJobType["AzureSapHanaVmBackup"] = "AZURE_SAP_HANA_VM_BACKUP";
    BackupJobType["AtlasMongodbClusterBackup"] = "ATLAS_MONGODB_CLUSTER_BACKUP";
    BackupJobType["AtlasMongodbClusterBackupFull"] = "ATLAS_MONGODB_CLUSTER_BACKUP_FULL";
    BackupJobType["GoogleWorkspaceBackup"] = "GOOGLE_WORKSPACE_BACKUP";
    BackupJobType["Microsoft365Backup"] = "MICROSOFT_365_BACKUP";
    BackupJobType["AzureEntraIdBackup"] = "AZURE_ENTRA_ID_BACKUP";
    BackupJobType["ClaudeEnterpriseBackup"] = "CLAUDE_ENTERPRISE_BACKUP";
})(BackupJobType || (BackupJobType = {}));
